// data/termsOfUse.ts
export const termsOfUse = [
  {
    section: '1. No Legal Advice - Crucial Disclaimer',
    content: [
      "Legalligence offers AI tools for legal research and drafting. IT DOES NOT PROVIDE LEGAL ADVICE. Our AI is a tool, not a lawyer. Always consult a qualified attorney for legal advice. Using our service doesn't create an attorney-client relationship.",
    ],
  },
  {
    section: '2. Eligibility & Accounts',
    content: [
      "You must be 18 or older. You're responsible for your account security and providing accurate information.",
    ],
  },
  {
    section: '3. Your Responsibilities',
    content: [
      'Use our services lawfully. Do not:',
      {
        type: 'list',
        items: [
          'Submit unlawful or harmful content.',
          'Impersonate others.',
          'Disrupt our services or access them without authorization.',
          'Use our services to build competing products.',
          'Introduce malware.',
        ],
      },
    ],
  },
  {
    section: '4. Intellectual Property',
    content: [
      '**Our Content:** Legalligence owns all content, software, and AI models.',
      '**Your Content:** You own your submitted content. You grant us a license to use it to provide and improve the Services (including training our AI, often in anonymized form)',
    ],
  },
  {
    section: '5. Fees & Payments',
    content: [
      'Some features require payment. You agree to pay all applicable fees. Fees are generally non-refundable.',
    ],
  },
  {
    section: '6. Termination',
    content: [
      'You can stop using the services anytime. We can suspend or terminate your access for violating these Terms.',
    ],
  },
  {
    section: '7. Disclaimers',
    content: [
      "OUR SERVICES ARE PROVIDED 'AS IS' WITHOUT WARRANTIES. We don't guarantee they will be error-free, secure, or meet your specific needs. Relying on our AI is at your own risk.",
    ],
  },
  {
    section: '8. Limitation of Liability',
    content: [
      'Legalligence is not liable for any indirect, incidental, or consequential damages arising from your use or inability to use the services. Our total liability is limited to the amount you paid us in the past 12 months.',
    ],
  },
  {
    section: '9. Indemnification',
    content: [
      'You agree to compensate Legalligence for any claims arising from your breach of these Terms or misuse of our services.',
    ],
  },
  {
    section: '10. Governing Law',
    content: [
      'These Terms are governed by the laws of India. Any disputes will be resolved in the courts of chennai, Tamil Nadu, India.',
    ],
  },
  {
    section: '11. Changes to Terms',
    content: [
      'We may update these Terms. Your continued use after updates means you accept the changes.',
    ],
  },
  {
    section: '12. Contact Us',
    content: ['Questions? Reach us at - team@legalligence.in'],
  },
];
